// A research note: one falsifiable claim, and what stands behind it.
//
// Shut it is the claim alone, which is the point of insisting a note be one
// falsifiable sentence — a claim you cannot state in a sentence is a claim you
// have not finished having.
//
// The trash is the only way a note is ever retired. No function deletes one,
// so the research call can write freely and the author decides what stays.

import { Card } from "./Card";
import { SourceList, withCitations } from "./CommentCard";
import type { Note } from "./types";

interface Props {
  note: Note;
  onDismiss?: () => void;
  onGoToParagraph?: (id: string) => void;
}

export function NoteCard({ note, onDismiss, onGoToParagraph }: Props) {
  return (
    <Card
      kind="note"
      badge={<span className="kind-label">Note</span>}
      summary={note.claim}
      onDismiss={onDismiss}
    >
      <NoteBody note={note} />
      {note.anchors.length > 0 && onGoToParagraph && (
        <button
          type="button"
          className="text-button flush"
          onClick={() => onGoToParagraph(note.anchors[0]!)}
        >
          Go to the text
        </button>
      )}
    </Card>
  );
}

/** Everything under a note's claim. Shared with the comment card, which shows
 *  the notes it rests on underneath itself. */
export function NoteBody({ note }: { note: Note }) {
  return (
    <>
      {note.explanation && <p className="explanation">{withCitations(note.explanation)}</p>}
      {note.evidence && (
        <p className="evidence">
          <span className="label">Evidence:</span> {withCitations(note.evidence)}
        </p>
      )}
      {note.sources.length > 0 && <SourceList sources={note.sources} />}
    </>
  );
}
